import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { DEFAULT_GC_TIME } from '@/client/constants';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { TimeseriesData } from '@/client/types/ai-management';
import { aiKeys, unwrapEnvelope } from './overview.query';

const TIMESERIES = '/llm-admin/usage/timeseries';

export interface TimeseriesParams {
  since_hours: number;
  bucket_hours: number;
}

const useTimeseriesFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (params: TimeseriesParams): Promise<TimeseriesData> => {
    const qs = new URLSearchParams({
      since_hours: String(params.since_hours),
      bucket_hours: String(params.bucket_hours),
    }).toString();
    const raw = await request<any>(`${TIMESERIES}?${qs}`);
    return unwrapEnvelope<TimeseriesData>(raw);
  }, 'Failed to load LLM usage timeseries');
};

export const useTimeseriesQuery = (params: TimeseriesParams, enabled = true) => {
  const queryFn = useTimeseriesFn();
  return useQuery({
    queryKey: aiKeys.timeseries(params),
    queryFn: () => queryFn(params),
    enabled,
    staleTime: 1000 * 30,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
